exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#file-drag-drop{margin-bottom:2em}#file-drag-drop form{display:block;height:100px;background:#ccc;text-align:center;line-height:100px;border-radius:4px}form.is-dragover{background-color:#17c4ee;color:#fff}div.file-listing{margin:auto;border-bottom:1px solid #ddd}div.file-listing table{margin:0;font-size:.9em;line-height:1.8em}div.file-listing table .icon{font-size:1.2em}div.file-listing img{height:100px}div.remove-container{text-align:center}div.remove-container a{color:red;cursor:pointer}a.submit-button{text-align:center;width:200px;padding:10px;text-transform:uppercase;background-color:#ccc;color:#fff;font-weight:700}a.submit-button,progress{display:block;margin:auto;margin-top:20px}progress{width:400px;margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fdf823d","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modules/FileManagement/Resources/assets/js/components/FileDragDropInstant.vue
// module id = ZjAs
// module chunks = 0